import icon1 from '../assets/view/box-1.png';
import icon2 from '../assets/view/box-2.png';
import icon3 from '../assets/view/box-3.png';
import iconLine from '../assets/view/box-line.png';

/* секция задача */
export function View() {
  return (
    <div className="web-page-new" data-model-id="877:8470">
      <div className="view">
        <div className="text-wrapper">Задача</div>
        <div className="frame">
          <div className="div">
            <img
              className="group"
              alt="Group"
              src={icon1}
            />
            <p className="p">
              Разработать умную админку или микросервис с ИИ-агентом, который по
              текстовому промпту генерирует изображения ианимации для трибун
              стадиона.
            </p>
          </div>
          <div className="frame-2">
            <div className="frame-3">
              <div className="frame-4">
                <img
                  className="vector"
                  alt="Vector"
                  src={icon2}
                />
                <div className="text-wrapper-2">Требования к решению:</div>
              </div>
              <ul className="text-wrapper-3">
                <li>принимать текстовый запрос</li>
                <li>генерировать пиксельную графику в логике трибун</li>
                <li>накладывать результат на развертку трибун ЦСКА</li>
                <li>поддерживать статичный и анимированный контент</li>
                <li>учитывать реальные ограничения показа</li>
                <li>помогать организаторам быстро готовить визуальный перформанс</li>
              </ul>
            </div>
            <div className="frame-5">
              <div className="frame-6">
                <div className="frame-4">
                  <img
                    className="img"
                    alt="Group"
                    src={icon3}
                  />
                  <div className="text-wrapper-2">Функционал:</div>
                </div>
                <ul className="text-wrapper-4">
                  <li>интерфейс админки, где можно задать промпт</li>
                  <li>генерация статичного изображения</li>
                  <li>генерация gif или покадровой анимации</li>
                  <li>наложение результата на развертку трибун</li>
                  <li>предпросмотр итогового перформанса</li>
                  <li>возможность экспорта сценария отображения</li>
                </ul>
              </div>
              <div className="frame-7">
                <div className="text-wrapper-5">Дополнительно:</div>
                <p className="text-wrapper-4">
                  сценарии переходов, ручную доработку результата, учет “битых
                  пикселей” и пустых мест, художественные эффекты.
                </p>
              </div>
            </div>
          </div>
        </div>
        <img
          className="line"
          alt="Line"
          src={iconLine}
        />
      </div>
    </div>
  )
}